import React from "react"
import { GlobalTableStyles } from "./globalTableStyles"
import { QuestionDetails } from "../../../Models/applicationModels"
import { ConfigProvider, Select } from "antd"
import { capitalizeFirstLetter, generateHierarchicalIndex } from "../../../utils/stringUtils"
import { mapAnswersToOptions, processSelectOptions } from "../../../utils/answerUtils"

interface IRecursiveRowProps {
    data: QuestionDetails[], parentIndex: string
}

const DeclineDetailsRow = (props: IRecursiveRowProps) => {

    const { data, parentIndex } = props
    const { tableCell, answerListMenu } = GlobalTableStyles().classes

    return (
        <>
            {data?.map((rowValue: QuestionDetails, index: number) => {
                const currentIndex = generateHierarchicalIndex(parentIndex, index + 1);
                const mappedAnswer = mapAnswersToOptions(rowValue);

                return (
                    <>
                        <tr>
                            <td className={tableCell}>
                                {currentIndex}
                            </td>
                            <td className={tableCell}>
                                {rowValue.questionTitle}
                            </td>
                            <td className={tableCell}>
                                {rowValue.questionOptions?.length > 0
                                    ?
                                    <ConfigProvider renderEmpty={() => "No Options"} >
                                        <Select
                                            {...(mappedAnswer.length > 1 && {mode: "tags"})}
                                            removeIcon={false}
                                            className={answerListMenu}
                                            value={mappedAnswer}
                                            options={processSelectOptions(rowValue.questionOptions, capitalizeFirstLetter)}
                                        />
                                    </ConfigProvider>
                                    :
                                    rowValue["answer"].toString()
                                }
                            </td>
                        </tr>
                        {rowValue.childQuestions?.length > 0 &&
                            <DeclineDetailsRow data={rowValue.childQuestions} parentIndex={currentIndex} />
                        }
                    </>
                )
            })}
        </>
    )
}

export default DeclineDetailsRow;